module.exports = __webpack_public_path__ + "static/media/adept-test-logo.6fbd0fd9.svg";